var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"04e5f0bcef8ed9f284dcbd39cc33297d6e0a9654"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"04e5f0bcef8ed9f284dcbd39cc33297d6e0a9654"};
      